import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import loadable from "@loadable/component";

const Home = loadable(() => import("./views/Home/Home"));
const Tasting = loadable(() => import("./views/Tasting/Tasting"));
const Brochure = loadable(() => import("./views/Brochure/Brochure"));

// const Tourism = loadable(() => import("./views/Tourism/Tasting"));
// const Events = loadable(() => import("./views/Event/Tasting"))

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        {/* tasting */}
        <Route exact path="/brochure/:code" component={Brochure} />

        <Route exact path="/:type/:code" component={Tasting} />

        {/* <Route exact path="/tourism/:code" component={Tourism} />
        <Route exact path="/event/:code" component={Events} /> */}
        <Redirect to="/" />
        {/* si el path no hace match con alguna de las rutas anteriores lo redirige al home */}
      </Switch>
    </Router>
  );
}

export default App;
